/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

export enum EDataType {
  BYTES = 'Bytes',
  BITS = 'Bits',
}

export function formatBytes(bytes: number, valueType: EDataType = EDataType.BYTES) {
  if (bytes) {
    const sizes =
      valueType === EDataType.BITS ? ['bit', 'kbit', 'Mbit', 'Gbit', 'Tbit'] : ['Bytes', 'kB', 'MB', 'GB', 'TB'];

    const i = Math.min(parseInt(Math.floor(Math.log(bytes) / Math.log(1000)).toString(), 10), sizes.length - 1);

    return `${(bytes / 1000 ** i).toFixed(i ? 2 : 0)} ${sizes[i]}`;
  }
  return 'n/a';
}
